
    <ng-container *ngIf="showLoading">
      <div class="loading-backdrop">
        <span class="spinner"></span>
        <span *ngIf="progress && progress.length" class="progress">{{progress[0].progress}}</span>
      </div>
    </ng-container>
    <router-outlet></router-outlet>
  


// WEBPACK FOOTER //
// ./src/app/app.component.ts.AppComponent.html